<template>
  <b-container class="mt-5">
    <b-card>
      <div class="row">
        <div class="col padded-card">
          <h2>Logged Out successfully</h2>
          <router-link to="/login">Login</router-link>
        </div>
      </div>
    </b-card>
  </b-container>
</template>
<script>
export default {
  mounted: function() {}
};
</script>

<style lang="scss" scoped>
.padded-card {
  padding-top: 5em;
  padding-bottom: 5em;
}
</style>
